export enum SpreadsheetDashboardType {
  InvoicesByCustomerAmount = 0,
  InvoicesByCustomerPercentage = 1,
  InvoicesByFamilyAmount = 2,
  InvoicesByFamilyPercentage = 3,
  InvoicesByFamilyQuantity = 4,
  InvoicesByItemAmount = 5,
  InvoicesByItemPercentage = 6,
  InvoicesByItemQuantity = 7,
  InvoicesByYear = 8,
  InvoicesByCustomerDiscountAmount = 9,
  InvoicesByCustomerDeliveryFormDiscountAmount = 10,
  InvoicesByFamilyDeliveryFormDiscountAmount = 11,
  InvoicesByFamilyDeliveryFormDiscountQuantity = 12,
  InvoicesByItemDeliveryFormDiscountAmount = 13,
  InvoicesByItemDeliveryFormDiscountQuantity = 14,
  ActivityByLaboratoryResourceAmountByMonth = 15,
  ActivityByLaboratoryResourceAmountByYear = 16,
  ActivityByLaboratoryResourceDurationByMonth = 17,
  ActivityByLaboratoryResourceDurationByYear = 18,
  ActivityBySectorAmountByMonth = 19,
  ActivityBySectorAmountByYear = 20,
  ActivityBySectorDurationByMonth = 21,
  ActivityBySectorDurationByYear = 22,
  ActivityByItemQuantityByLaboratoryResource = 23,
  ActivityByItemAmountByLaboratoryResource = 24,
}
